import Container from '@material-ui/core/Container'
import Box from '@material-ui/core/Box'
import Card from '@material-ui/core/Card'
import React, { FunctionComponent } from 'react'
import {
  createStyles,
  makeStyles,
  Theme,
  useTheme
} from '@material-ui/core/styles'
import { useMediaQuery } from '@material-ui/core'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    loginRoot: {
      [theme.breakpoints.up('sm')]: {
        backgroundImage:
          'url(https://img2.storyblok.com/f/82218/1920x1280/47143bb847/technology-785742_1920.jpg)',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        minHeight: '100vh'
      },
      display: 'flex'
    },
    loginContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  })
)

const AuthWrap: FunctionComponent = ({ children }) => {
  const classes = useStyles()
  const theme = useTheme()
  const biggerXs = useMediaQuery(theme.breakpoints.up('sm'))
  return (
    <div className={classes.loginRoot}>
      <Container maxWidth="sm" className={classes.loginContainer}>
        {biggerXs ? (
          <Box my={5} style={{ textAlign: 'center' }}>
            <img
              src={
                'https://img2.storyblok.com//f/82218/256x128/252c895682/logo-pa.png'
              }
              alt={'logo praktikumsanzeigen'}
              height={80}
            />
            <Card
              raised
              style={{ backgroundColor: 'rgba(255, 255, 255, 0.9)' }}
              elevation={6}
            >
              {children}
            </Card>
          </Box>
        ) : (
          <div>
            <div style={{ textAlign: 'center' }}>
              <img
                src={
                  'https://img2.storyblok.com//f/82218/256x128/252c895682/logo-pa.png'
                }
                alt={'logo praktikumsanzeigen'}
                height={64}
              />
            </div>
            {children}
          </div>
        )}
      </Container>
    </div>
  )
}

export default AuthWrap
